import { ReasonInput } from '@strata/react-compound-inputs';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { accept277CA } from 'api/medbillingAPI';
import { handleError } from 'services/Error';
import { useRefetchAllClaimDetails } from 'store/api/medbillingApi';

const Title = 'Update 277 CA Status';

const ReasonOptions = ['Confirmed with Payer', 'Payer Error', 'Processing Issue'];

const ValidationSchema = Yup.object({ ...ReasonInput.validationSchema });

interface Update277CAStatusDialogProps {
    onClose: () => void;
    payerId: string;
    transactionId: string;
}

export const Update277CAStatusDialog = ({
    onClose,
    payerId,
    transactionId,
}: Update277CAStatusDialogProps) => {
    const refetchAllClaimDetails = useRefetchAllClaimDetails({
        payerId,
        transactionId,
    });
    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            validationSchema={ValidationSchema}
            onSubmit={async (values, { resetForm }) => {
                try {
                    await accept277CA({
                        transactionId,
                        payerId,
                        ...ReasonInput.submitValues(values),
                    });

                    refetchAllClaimDetails();

                    SuccessToast({ message: '277 CA status updated to accepted.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError('Unable to update 277 CA status. Please try again.', err as Error);
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    isOpen
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Update Status"
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                This action will update the status of the 277 CA to accepted.
                            </div>
                            <ReasonInput reasons={ReasonOptions} />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

Update277CAStatusDialog.Title = Title;
